const sectionFreestyleInfoCss = `
[data-type='section-freestyle-info'] .freestyle-info-wrapper {
  background-color: var(--background-color, #ffffff);
  color: var(--text-color, #000000);
}

[data-type='section-freestyle-info'] .freestyle-info-wrapper[data-top-padding='true'] {
  padding-top: 40px;
}

[data-type='section-freestyle-info'] .freestyle-info-wrapper[data-bottom-padding='true'] {
  padding-bottom: 40px;
}

[data-type='section-freestyle-info'] .freestyle-info-container {
  display: flex;
  flex-direction: column;
  gap: 32px;
  position: relative;
}

[data-type='section-freestyle-info'] .freestyle-info-product-facts,
[data-type='section-freestyle-info'] .freestyle-info-direction-for-use,
[data-type='section-freestyle-info'] .freestyle-info-table {
  position: relative;
  width: 50%;
  margin: 0 auto;
}

[data-type='section-freestyle-info'] .freestyle-info-product-facts h1,
[data-type='section-freestyle-info'] .freestyle-info-product-facts h2,
[data-type='section-freestyle-info'] .freestyle-info-product-facts h3,
[data-type='section-freestyle-info'] .freestyle-info-direction-for-use h1,
[data-type='section-freestyle-info'] .freestyle-info-direction-for-use h2,
[data-type='section-freestyle-info'] .freestyle-info-direction-for-use h3,
[data-type='section-freestyle-info'] .freestyle-info-table h1,
[data-type='section-freestyle-info'] .freestyle-info-table h2,
[data-type='section-freestyle-info'] .freestyle-info-table h3 {
  font-size: 24px;
  line-height: normal;
  margin: 0 0 16px 0 !important;
}

[data-type='section-freestyle-info'] .freestyle-info-product-facts h1:last-child,
[data-type='section-freestyle-info'] .freestyle-info-product-facts h2:last-child,
[data-type='section-freestyle-info'] .freestyle-info-product-facts h3:last-child,
[data-type='section-freestyle-info'] .freestyle-info-direction-for-use h1:last-child,
[data-type='section-freestyle-info'] .freestyle-info-direction-for-use h2:last-child,
[data-type='section-freestyle-info'] .freestyle-info-direction-for-use h3:last-child,
[data-type='section-freestyle-info'] .freestyle-info-table h1:last-child,
[data-type='section-freestyle-info'] .freestyle-info-table h2:last-child,
[data-type='section-freestyle-info'] .freestyle-info-table h3:last-child {
  margin-bottom: 0 !important;
}

[data-type='section-freestyle-info'] .freestyle-info-product-facts p,
[data-type='section-freestyle-info'] .freestyle-info-direction-for-use p,
[data-type='section-freestyle-info'] .freestyle-info-table p {
  font-size: 16px;
  margin: 0 0 8px 0 !important;
  line-height: normal;
}

[data-type='section-freestyle-info'] .freestyle-info-product-facts p:last-child,
[data-type='section-freestyle-info'] .freestyle-info-direction-for-use p:last-child,
[data-type='section-freestyle-info'] .freestyle-info-table p:last-child {
  margin-bottom: 0 !important;
}

[data-type='section-freestyle-info'] .freestyle-info-product-facts figure,
[data-type='section-freestyle-info'] .freestyle-info-direction-for-use figure,
[data-type='section-freestyle-info'] .freestyle-info-table figure {
  overflow-x: auto;
  overflow-y: hidden;
}

[data-type='section-freestyle-info'] .freestyle-info-product-facts table,
[data-type='section-freestyle-info'] .freestyle-info-direction-for-use table,
[data-type='section-freestyle-info'] .freestyle-info-table table {
  border: none;
}

[data-type='section-freestyle-info'] .freestyle-info-product-facts table thead th,
[data-type='section-freestyle-info'] .freestyle-info-direction-for-use table thead th,
[data-type='section-freestyle-info'] .freestyle-info-table table thead th {
  background-color: var(--table-header-background-color, #14a16c);
  color: var(--table-header-text-color, #ffffff);
  border: none;
  font-size: 18px;
  padding: 16px;
}

[data-type='section-freestyle-info'] .freestyle-info-product-facts table tbody tr:nth-child(odd),
[data-type='section-freestyle-info'] .freestyle-info-direction-for-use table tbody tr:nth-child(odd),
[data-type='section-freestyle-info'] .freestyle-info-table table tbody tr:nth-child(odd) {
  background-color: var(--table-old-row-background-color, #d6dad9);
  color: var(--table-old-row-text-color, #000000);
}

[data-type='section-freestyle-info'] .freestyle-info-product-facts table tbody td,
[data-type='section-freestyle-info'] .freestyle-info-direction-for-use table tbody td,
[data-type='section-freestyle-info'] .freestyle-info-table table tbody td {
  border: none;
  padding: 16px;
  font-weight: 500 !important;
}

[data-type='section-freestyle-info'] .freestyle-info-images {
  display: none;
}

[data-type='section-freestyle-info'] .freestyle-info-product-facts-wrapper,
[data-type='section-freestyle-info'] .freestyle-info-direction-for-use-wrapper {
  position: relative;
}

[data-type='section-freestyle-info'] .freestyle-info-product-facts-wrapper .freestyle-info-image-2 {
  display: block;
  position: absolute;
  top: 0;
  right: 20%;
  max-width: 200px;
  width: 100%;
}

[data-type='section-freestyle-info'] .freestyle-info-product-facts-wrapper .freestyle-info-image-2 img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

[data-type='section-freestyle-info'] .freestyle-info-direction-for-use-wrapper .freestyle-info-image-1 {
  display: block;
  position: absolute;
  top: 0;
  left: 0;
  max-width: 450px;
  width: 100%;
}

[data-type='section-freestyle-info'] .freestyle-info-direction-for-use-wrapper .freestyle-info-image-1 img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

@container (max-width: 768px) {
  [data-type='section-freestyle-info'] .freestyle-info-wrapper[data-top-padding='true'] {
    padding-top: 16px;
  }

  [data-type='section-freestyle-info'] .freestyle-info-wrapper[data-bottom-padding='true'] {
    padding-bottom: 16px;
  }

  [data-type='section-freestyle-info'] .freestyle-info-product-facts,
  [data-type='section-freestyle-info'] .freestyle-info-direction-for-use,
  [data-type='section-freestyle-info'] .freestyle-info-table {
    width: 100%;
  }

  [data-type='section-freestyle-info'] .freestyle-info-product-facts h1,
  [data-type='section-freestyle-info'] .freestyle-info-product-facts h2,
  [data-type='section-freestyle-info'] .freestyle-info-product-facts h3,
  [data-type='section-freestyle-info'] .freestyle-info-direction-for-use h1,
  [data-type='section-freestyle-info'] .freestyle-info-direction-for-use h2,
  [data-type='section-freestyle-info'] .freestyle-info-direction-for-use h3,
  [data-type='section-freestyle-info'] .freestyle-info-table h1,
  [data-type='section-freestyle-info'] .freestyle-info-table h2,
  [data-type='section-freestyle-info'] .freestyle-info-table h3 {
    font-size: 20px;
  }

  [data-type='section-freestyle-info'] .freestyle-info-product-facts p,
  [data-type='section-freestyle-info'] .freestyle-info-direction-for-use p,
  [data-type='section-freestyle-info'] .freestyle-info-table p {
    font-size: 14px;
  }

  [data-type='section-freestyle-info'] .freestyle-info-product-facts figure,
  [data-type='section-freestyle-info'] .freestyle-info-direction-for-use figure,
  [data-type='section-freestyle-info'] .freestyle-info-table figure {
    width: 98% !important;
  }

  [data-type='section-freestyle-info'] .freestyle-info-images {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 32px;
  }

  [data-type='section-freestyle-info'] .freestyle-info-images .freestyle-info-image-1 {
    width: 50%;
  }

  [data-type='section-freestyle-info'] .freestyle-info-images .freestyle-info-image-1 img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  [data-type='section-freestyle-info'] .freestyle-info-images .freestyle-info-image-2 {
    width: 25%;
  }

  [data-type='section-freestyle-info'] .freestyle-info-images .freestyle-info-image-2 img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  [data-type='section-freestyle-info'] .freestyle-info-product-facts-wrapper .freestyle-info-image-2 {
    display: none;
  }

  [data-type='section-freestyle-info'] .freestyle-info-direction-for-use-wrapper .freestyle-info-image-1 {
    display: none;
  }
}
`;
export default sectionFreestyleInfoCss;
